module.exports = __webpack_public_path__ + "img/icon (16).bcb32d20.png";